/* AntiFight — Paket H: mobil menü kapanınca odağı hamburger (summary) düğmesine geri döndür.
   Horizon'un kendi açma/kapama, focus-trap ve scroll-lock mantığına dokunmaz; yalnız kapanış sonrası
   odak body'de kalırsa summary'ye taşır. */
(function () {
  var d = document.getElementById('Details-menu-drawer-container');
  if (!d) return;
  var s = d.querySelector('summary');
  if (!s) return;
  d.addEventListener('toggle', function () {
    if (d.open) return;
    var a = document.activeElement;
    if (!a || a === document.body || d.contains(a)) {
      try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); }
    }
  });
})();
